var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("name"),_vm._v(" "),_c('p',{class:_vm.className,style:({textAlign: 'center', color: _vm.color, fontSize: _vm.countSize, fontWeight: _vm.countWeight})},[_c('span',{attrs:{"id":_vm.idName}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.unit))])]),_vm._v(" "),_vm._t("intro")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4be4536","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/components/countUp.vue
// module id = null
// module chunks = 